import React, { useContext } from 'react';
import {
    Modal,
} from 'components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { DocumentsContext, HomeContext } from 'contexts';
import { StatusTradeTrust } from 'actions';

export const SurrenderDocument = ({open, onCancel}) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { doSurrenderDocument, documentInfo } = useContext(DocumentsContext);
    const { walletVerify, setCallbackParties, setPleaseAwait, setStatusBlockChain, setCurrentStatus } = useContext(HomeContext);
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];
    
    const handleConfirmSurender = () => {
        const payload = {
            merkleRoot:documentInfo?.merkleRoot,
            organizationId:walletVerify?.orgId,
            tokenRegistryAddress:documentInfo?.tokenRegistryAddress,
            walletPassword:documentInfo?.walletPassword,
            isDemo:false
        };
        const header = {
            wallet: walletVerify?.address,
            blockchain: "Ethereum",
            orgId: walletVerify?.orgId,
        }
        if(docId){
            doSurrenderDocument(docId, payload, header, (data) => {
                if(data) {
                    setPleaseAwait(true);
                    setCallbackParties(true);
                    setStatusBlockChain([{key: 6, value: 'Surrender started'}]);
                    setCurrentStatus(StatusTradeTrust.SERRENDER_STARTED);
                    onCancel();
                }
            })
        }
    }

    return (
        <Modal
            open={open}
            className="tr__surender--document"
            onCancel={onCancel}
            title="Confirm surrender document"
            btnClasses="justify-content-center"
            submitButton
            submitButtonLabel={t("home.delete-task.yes")}
            onSubmitClick={handleConfirmSurender}
            cancelButton={true}
            cancelButtonLabel={t("home.delete-task.no")}
            cancelButtonType=""
            cancelButtonClassNames="outline secondary"
            onCancelClick={onCancel}
            isBackDropClickable={false}
        >
            <div className="text-center">
                <h6 className="h6 mtbx4 f-medium">Are you sure you wish to surrender the document ?</h6>
            </div>
        </Modal>
    )
};